var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnicorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 26 25",
    className: "header__user-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 7 4-4.5M15 2v1.5c.167.5.9 1.8 2.5 3s4.667 3.833 6 5c.833.833 2 2.9 0 4.5-1.455 1.164-2.999.546-4.053-.199-.65-.459-1.394-.801-2.19-.801H15.5c-.667-.167-2.5-3.5-2.5-3l3.846 9.23A2 2 0 0 1 15 24H5M15 2c-4.833-.5-17 .5-13 18 .643 2.815 1 3.5 3 4M15 2c-3.6 0-3.833 2.666-3.5 4-4 2-5 3.625-5.5 4.5-1.385 2.423-.372 5.521 1.87 7.608.682.634 1.348 1.377 1.38 2.308C9.348 23.244 6.594 24 5 24",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicorn);
export default __webpack_public_path__ + "static/media/Unicorn.893f61f5f1e4c9174d7f62884953bc2f.svg";
export { ForwardRef as ReactComponent };